import { combineReducers } from 'redux';

import globalEventOccurrenceSearch from '../../global/eventOccurrenceSearchDrawer/eventOccurrenceSearchDrawer.reducers.js';
import eventEdit from '../eventDetails/index.reducers';
import paidEvent from '../eventDetails/paidEvent/paidEvent.reducers';
import accommodation from './accommodation.js';
import category from './category.js';
import event from './event.js';
import eventAttendee from './EventAttendee/index.js';
import eventCache from './eventCache.js';
import eventOccurrenceVenue from './eventOccurrenceVenue.js';
import eventsSearchFilters from './eventsSearchFilters.js';
import reminder from './reminder.js';
import roomCategory from './roomCategory.js';
import tag from './tag.js';

const reducers = combineReducers({
    accommodation,
    category,
    event,
    eventAttendee,
    eventCache,
    eventEdit,
    eventOccurrenceVenue,
    eventsSearchFilters,
    globalEventOccurrenceSearch,
    reminder,
    roomCategory,
    tag,
    paidEvent,
});

export default reducers;
